// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../assets/images/logo/agentic_pattern.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aa-agentic-copilot-node-wrapper {
  height: auto;
  width: 100%;
  padding: 10px;
}

.assist-empty-agentic {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.agentic-copilot-node-header {
  display: flex;
  gap: 4px;
  width: 100%;
  display: flex;
  align-items: center;
}
.agentic-copilot-node-header .agentic-node-icon {
  width: 34px;
  height: 34px;
  background-color: var(--AA-gloabl-bg-secondary);
}
.agentic-copilot-node-header .agentic-node-query-title {
  padding: 8px 12px;
  border-radius: 12px 12px 12px 4px;
  background: var(--AA-gloabl-bg-secondary);
}
.agentic-copilot-node-header .agentic-node-regenerate-input-wrapper .regenerate-input {
  height: 34px;
  border: 1px solid var(--AA-global-theme-bg);
  background: var(--AA-global-white-bg);
}
.agentic-copilot-node-header .agentic-node-regenerate-input-wrapper .regenerate-copy-cancel {
  top: 50%;
  transform: translateY(-50%);
  right: 15px;
}

.aa-agentic-copilot-node-body {
  background: linear-gradient(var(--AA-gloabl-bg-secondary), var(--AA-gloabl-bg-secondary)) padding-box, linear-gradient(0deg, #AD00FE, #00E0EE 43%, #00E0EE) border-box !important;
  border: 1px solid transparent !important;
}
.aa-agentic-copilot-node-body:hover .agentic-send-or-copy-actions {
  visibility: visible;
}
.aa-agentic-copilot-node-body:hover .aa-sent-text {
  display: none;
}
.aa-agentic-copilot-node-body:hover .agentic-text-contrast {
  max-height: none;
  -webkit-line-clamp: unset;
}
.aa-agentic-copilot-node-body::before {
  content: "";
  background: var(--AA-global-theme-bg);
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  border-radius: 10px;
  opacity: 0.1;
}
.aa-agentic-copilot-node-body .agentic-send-or-copy-actions {
  visibility: hidden;
  right: 25px;
  top: -14px;
  background: var(--AA-global-white-bg);
  z-index: 2;
  padding: 2px;
  box-shadow: 0 12px 16px -4px var(--Focus-Ring-Neutral-8-pg, rgba(16, 24, 40, 0.08)), 0 4px 6px -2px var(--Focus-Ring-Neutral-4-pg, rgba(16, 24, 40, 0.04));
}
.aa-agentic-copilot-node-body .agentic-send-or-copy-actions .aa-agentic-sent-text {
  color: var(--AA-global-theme-text-color);
}
.aa-agentic-copilot-node-body .agentic-send-or-copy-actions .aa-agentic-copy-btn {
  padding: var(--xxs, 2px) var(--default, 8px);
}
.aa-agentic-copilot-node-body .agentic-send-or-copy-actions.aa-sent-text {
  visibility: visible;
  color: var(--AA-global-theme-text-color);
}
.aa-agentic-copilot-node-body .aa-agentic-send-dyn-btn {
  right: 25px;
  top: -11px;
  background: var(--AA-global-white-bg);
  z-index: 2;
  box-shadow: 0 12px 16px -4px var(--Focus-Ring-Neutral-8-pg, rgba(16, 24, 40, 0.08)), 0 4px 6px -2px var(--Focus-Ring-Neutral-4-pg, rgba(16, 24, 40, 0.04));
}

.agentic-node-thinking-section {
  font-style: italic;
}
.agentic-node-thinking-section .call-connecting-progress-wave .call-connecting-dot {
  display: inline-block;
  width: 4px;
  height: 4px;
  background: var(--AA-global-theme-bg);
  animation: connectingWave 1.5s linear infinite;
}
.agentic-node-thinking-section .call-connecting-progress-wave .call-connecting-dot:nth-child(2) {
  animation-delay: -1.1s;
}
.agentic-node-thinking-section .call-connecting-progress-wave .call-connecting-dot:nth-child(3) {
  animation-delay: -0.9s;
}
@keyframes connectingWave {
  0%, 60%, 100% {
    transform: initial;
  }
  30% {
    transform: translateY(-6px);
  }
}

.aa-agentic-override-input-wrapper {
  width: 100%;
  height: 20px;
  border: 2px solid black;
  background-color: #F9FAFB;
}
.aa-agentic-override-input-wrapper .aa-agentic-override-input {
  height: 100%;
  width: 100%;
}

.aa-input-fixed-text-block {
  border: 1px solid var(--AA-global-theme-bg);
  margin-top: 8px;
}
.aa-input-fixed-text-block input {
  border: none;
  outline: none;
  background: transparent;
}

.input-text-btn {
  background: none;
  border: none;
  width: 20px;
  height: 20px;
}

.agentic-text-contrast {
  max-height: 1.5em;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  transition: max-height 0.3s ease;
}

.highlight-agentic-block-content {
  background: linear-gradient(var(--AA-global-white-bg), var(--AA-global-white-bg)) padding-box, linear-gradient(0deg, #AD00FE, #00E0EE 43%, #00E0EE) border-box !important;
  border: 1px solid transparent !important;
}

.border-class {
  border: 0px;
}

.inactive-auto-send svg path {
  stroke: var(--AA-primary-text);
}`, "",{"version":3,"sources":["webpack://./src/components/common/templatemanager/tabs/agentic-CoPilot/agentic-CoPilot.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,aAAA;AACJ;;AAGA;EACI,yDAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,aAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAAJ;AACI;EACI,WAAA;EACA,YAAA;EACA,+CAAA;AACR;AACQ;EACA,iBAAA;EACA,iCAAA;EACA,yCAAA;AACR;AAEY;EACI,YAAA;EACA,2CAAA;EACA,qCAAA;AAAhB;AAEY;EACK,QAAA;EACA,2BAAA;EACA,WAAA;AAAjB;;AAMA;EACI,iLAAA;EACA,wCAAA;AAHJ;AAKQ;EACI,mBAAA;AAHZ;AAKQ;EACI,aAAA;AAHZ;AAMQ;EACI,gBAAA;EACA,yBAAA;AAJZ;AAOI;EACI,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,MAAA;EACA,mBAAA;EACA,YAAA;AALR;AAQI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,qCAAA;EACA,UAAA;EACA,YAAA;EACA,0JAAA;AANR;AAOQ;EACI,wCAAA;AALZ;AAOQ;EACI,4CAAA;AALZ;AAOQ;EACI,mBAAA;EACA,wCAAA;AALZ;AAQI;EACI,WAAA;EACA,UAAA;EACA,qCAAA;EACA,UAAA;EACA,0JAAA;AANR;;AAUA;EACI,kBAAA;AAPJ;AASS;EACI,qBAAA;EACA,UAAA;EACA,WAAA;EACA,qCAAA;EACA,8CAAA;AAPb;AAQa;EACI,sBAAA;AANjB;AAQa;EACI,sBAAA;AANjB;AASS;EACI;IACE,kBAAA;EAPb;EASW;IACE,2BAAA;EAPb;AACF;;AAaA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;AAVJ;AAWI;EACI,YAAA;EACA,WAAA;AATR;;AAcA;EACE,2CAAA;EACA,eAAA;AAXF;AAYE;EACE,YAAA;EACA,aAAA;EACA,uBAAA;AAVJ;;AAcA;EACI,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAXJ;;AAcA;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gCAAA;AAXJ;;AAcA;EACI,yKAAA;EACA,wCAAA;AAXJ;;AAcA;EACI,WAAA;AAXJ;;AAgBQ;EACI,8BAAA;AAbZ","sourcesContent":[".aa-agentic-copilot-node-wrapper{\n    height: auto;\n    width: 100%;\n    padding: 10px;\n    \n}\n\n.assist-empty-agentic{\n    background-image: url('../../../../../assets/images/logo/agentic_pattern.svg');\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.agentic-copilot-node-header{\n    display: flex;\n    gap: 4px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    .agentic-node-icon{\n        width: 34px;\n        height: 34px;\n        background-color: var(--AA-gloabl-bg-secondary);\n    }\n        .agentic-node-query-title{\n        padding: 8px 12px;\n        border-radius: 12px 12px 12px 4px;\n        background: var(--AA-gloabl-bg-secondary);\n        }\n        .agentic-node-regenerate-input-wrapper{\n            .regenerate-input{\n                height: 34px;\n                border: 1px solid var(--AA-global-theme-bg);\n                background: var(--AA-global-white-bg);\n            }\n            .regenerate-copy-cancel{\n                 top: 50%;\n                 transform: translateY(-50%);\n                 right: 15px;\n            }\n        }\n    \n}\n\n.aa-agentic-copilot-node-body{\n    background: linear-gradient(var(--AA-gloabl-bg-secondary), var(--AA-gloabl-bg-secondary)) padding-box, linear-gradient(0deg, #AD00FE, #00E0EE 43%, #00E0EE) border-box !important;\n    border: 1px solid transparent !important;\n    &:hover {\n        .agentic-send-or-copy-actions {\n            visibility: visible;\n        }\n        .aa-sent-text {\n            display: none;\n        }\n        \n        .agentic-text-contrast{\n            max-height: none;\n            -webkit-line-clamp: unset;\n        }\n    }\n    &::before{\n        content: \"\";\n        background: var(--AA-global-theme-bg);\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        z-index: 1;\n        left: 0;\n        top: 0;\n        border-radius: 10px;\n        opacity: 0.1;\n    }\n    // Add the actions container\n    .agentic-send-or-copy-actions {\n        visibility: hidden;\n        right: 25px;\n        top: -14px;\n        background: var(--AA-global-white-bg);\n        z-index: 2;\n        padding: 2px;\n        box-shadow: 0 12px 16px -4px var(--Focus-Ring-Neutral-8-pg, rgba(16, 24, 40, 0.08)), 0 4px 6px -2px var(--Focus-Ring-Neutral-4-pg, rgba(16, 24, 40, 0.04));\n        .aa-agentic-sent-text{\n            color: var(--AA-global-theme-text-color);\n        }\n        .aa-agentic-copy-btn{\n            padding: var(--xxs, 2px) var(--default, 8px);\n        }\n        &.aa-sent-text{\n            visibility: visible;\n            color: var(--AA-global-theme-text-color);\n        }\n    }\n    .aa-agentic-send-dyn-btn{\n        right: 25px;\n        top: -11px;\n        background: var(--AA-global-white-bg);\n        z-index: 2;\n        box-shadow: 0 12px 16px -4px var(--Focus-Ring-Neutral-8-pg, rgba(16, 24, 40, 0.08)), 0 4px 6px -2px var(--Focus-Ring-Neutral-4-pg, rgba(16, 24, 40, 0.04));\n    }\n}\n\n.agentic-node-thinking-section{\n    font-style: italic;\n    .call-connecting-progress-wave {\n         .call-connecting-dot {\n             display: inline-block;\n             width: 4px;\n             height: 4px;\n             background: var(--AA-global-theme-bg);\n             animation: connectingWave 1.5s linear infinite;\n             &:nth-child(2){\n                 animation-delay: -1.1s;\n             }\n             &:nth-child(3){\n                 animation-delay: -0.9s;\n             }\n         }\n         @keyframes connectingWave {\n             0%, 60%, 100% {\n               transform: initial;\n             }\n             30% {\n               transform: translateY(-6px);\n             }\n         }      \n     }\n}\n\n\n.aa-agentic-override-input-wrapper{\n    width: 100%;\n    height: 20px;\n    border: 2px solid black;\n    background-color: #F9FAFB;\n    .aa-agentic-override-input{\n        height: 100%;\n        width: 100%;\n        \n    }\n}\n\n.aa-input-fixed-text-block {\n  border: 1px solid var(--AA-global-theme-bg);\n  margin-top: 8px;\n  input {\n    border: none;\n    outline: none;\n    background: transparent;\n  }\n}\n\n.input-text-btn{\n    background: none;\n    border: none;\n    width: 20px;\n    height: 20px;\n}\n\n.agentic-text-contrast{\n    max-height: 1.5em;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    transition: max-height 0.3s ease;\n}\n\n.highlight-agentic-block-content{\n    background: linear-gradient(var(--AA-global-white-bg), var(--AA-global-white-bg)) padding-box, linear-gradient(0deg, #AD00FE, #00E0EE 43%, #00E0EE) border-box !important;\n    border: 1px solid transparent !important;\n}\n\n.border-class{\n    border: 0px;\n}\n\n.inactive-auto-send{\n    svg{\n        path{\n            stroke: var(--AA-primary-text);\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
